var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("router-link", {
    attrs: {
      to: "/setting/edit/" + _vm.data.id
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-edit"
    }
  })], 1), _c("el-descriptions", {
    attrs: {
      title: "Setting Details",
      direction: "vertical",
      colon: false,
      "label-style": {
        "font-weight": "bold"
      }
    }
  }, [_c("el-descriptions-item", {
    attrs: {
      label: "Booking Amount Threshold"
    }
  }, [_c("inr", {
    attrs: {
      number: _vm.data.bookingAmountThreshold
    }
  })], 1), _c("el-descriptions-item", {
    attrs: {
      label: "Transaction %"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.transactionPercent) + " ")]), _c("el-descriptions-item", {
    attrs: {
      label: "Bank Details"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.bankInformation) + " ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };